window.addEventListener('DOMContentLoaded', event => {
  const intakeRequestNew = document.querySelector('.intake_request.new');

  if (intakeRequestNew) {
    const sections = document.querySelectorAll('.form-section');
    navigateTo(0); // Start at the beginning
  }

  function navigateTo(index) {
    // Mark the current section with the class 'current'
    document.querySelectorAll('.form-section').forEach((section) => {
      section.classList.remove('current');
    });

    const currentSection = Array.from(document.querySelectorAll('.form-section')).find(
      (section) => parseInt(section.dataset.questionIndex, 10) === index
    );

    if (currentSection) {
      currentSection.classList.add('current');
    }

    // Show only the navigation buttons that make sense for the current section:
    const previousButton = document.querySelector('.form-navigation .previous');
    if (previousButton) {
      previousButton.style.display = index > 0 ? 'inline-block' : 'none';
    }

    const atTheEnd = index >= document.querySelectorAll('.form-section').length - 1;
    const nextButton = document.querySelector('.form-navigation .next');
    const submitButton = document.querySelector('.form-navigation [type=submit]');

    if (nextButton) {
      nextButton.style.display = atTheEnd ? 'none' : 'inline-block';
    }

    if (submitButton) {
      submitButton.style.display = atTheEnd ? 'inline-block' : 'none';
    }
  }

  function curIndex() {
    // Return the current index by looking at which section has the class 'current'
    const currentSection = document.querySelector('.form-section.current');
    return currentSection ? parseInt(currentSection.dataset.questionIndex, 10) : 0;
  }

  function validateCurrentSection() {
    const currentSection = document.querySelector('.form-section.current');
    const formError = document.querySelector('.intake-form .form-error');
    if (!currentSection) return false;

    const selectedOption = currentSection.querySelector('input[type="radio"]:checked');
    if (!selectedOption) {
      formError.style.display = 'block';
      return false;
    }

    formError.style.display = 'none';
    return true;
  }

  // Hide form-error when an input is selected
  document.querySelectorAll('input[type="radio"]').forEach((input) => {
    input.addEventListener('change', () => {
      const formError = document.querySelector('.intake-form .form-error');
      if (formError) {
        formError.style.display = 'none';
      }
    });
  });

  // Previous button is easy, just go back
  const previousButton = document.querySelector('.form-navigation .previous');
  if (previousButton) {
    previousButton.addEventListener('click', function () {
      navigateTo(curIndex() - 1);
    });
  }

  // Next button goes forward if the current block validates
  const nextButton = document.querySelector('.form-navigation .next');
  if (nextButton) {
    nextButton.addEventListener('click', function () {
      if (validateCurrentSection()) {
        navigateTo(curIndex() + 1);
      }
    });
  }
});